import { useEffect, useState } from 'react';

const useRedirectURL = (pathname = '') => {
    const [url, setUrl] = useState({});

    useEffect(() => {
        setUrl(window.location.origin);
    }, []);

    const value = url + pathname;

    return value;
};

export default useRedirectURL;
